import { LOCALES } from './locales';

import { CMSPageIntl } from 'client/pages/CMSPage/CMSPage.intl';
import { errorSummaryIntl } from 'client/components/GDS/ErrorSummary/ErrorSummary.intl';
import { EnquiryFormIntl } from 'client/pages/EnquiriesPage/CreateEnquiryPage/EnquiryForm/EnquiryForm.intl';
import { workpackFormIntl } from 'client/pages/WorkpacksPage/CreateWorkpackPage/WorkpackForm/WorkpackForm.intl';
import { workpackSummaryIntl } from 'client/pages/WorkpacksPage/CreateWorkpackPage/WorkpackSummary/WorkpackSummary.intl';
import { workpackAlertsIntl } from 'client/pages/WorkpacksPage/components/WorkpackAlerts/WorkpackAlerts.intl';
import { workpackAlertSuccessIntl } from 'client/pages/WorkpacksPage/components/WorkpackAlerts/WorkpackAlertSuccess/WorkpackAlertSuccess.intl';
import { workpackAlertModalIntl } from 'client/pages/WorkpacksPage/components/WorkpackAlerts/WorkpackAlertModal/WorkpackAlertModal.intl';
import { activityTypeIntl as enquiryActivityTypeIntl } from 'client/pages/EnquiriesPage/CreateEnquiryPage/EnquiryActivityType/EnquiryActivityType.intl';
import { enquiryAlertsIntl } from 'client/pages/EnquiriesPage/components/EnquiryAlerts/EnquiryAlerts.intl';
import { enquiryAlertModalIntl } from 'client/pages/EnquiriesPage/components/EnquiryAlerts/EnquiryAlertModal/EnquiryAlertModal.intl';
import { enquiryWarningIntl } from 'client/pages/EnquiriesPage/components/EnquiryWarning/EnquiryWarning.intl';
import { ariaSearchIntl } from 'client/components/aria/Search/Search.intl';
import { assetOwnersIntl } from 'client/pages/MapPage/components/MapMenu/AssetOwners/AssetOwners.intl';
import { contactDetailsTabIntl } from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeaturePanel/ContactDetailsTab/ContactDetailsTab.intl';
import {
    assetsHiddenSnackBarIntl
} from 'client/pages/MapPage/components/SnackBars/AssetsHiddenSnackBar/AssetsHiddenSnackBar.intl';
import { autoLogoutIntl } from 'client/components/suc/AutoLogout/AutoLogout.intl';
import { bookmarkIntl } from 'client/pages/MapPage/components/MapToolBar/BookmarkButton/BookMark.intl';
import { bookmarkPageIntl } from 'client/pages/BookmarkPage/BookmarkPage.intl';
import { characterCountIntl } from 'client/components/GDS/CharacterCount/CharacterCount.intl';
import { contactDetailsIntl } from 'client/pages/MapPage/components/MapMenu/ContactDetails/ContactDetails.intl';
import { coverageAssetOwnersIntl } from 'client/pages/MapPage/components/MapMenu/CoverageAssetOwners/CoverageAssetOwner.intl';
import { createEnquiryPageIntl } from 'client/pages/EnquiriesPage/CreateEnquiryPage/CreateEnquiryPage.intl';
import { createWorkpackPageIntl } from 'client/pages/WorkpacksPage/CreateWorkpackPage/CreateWorkpackPage.intl';
import { viewWorkpackPageIntl } from 'client/pages/WorkpacksPage/ViewWorkpackPage/ViewWorkpackPage.intl';
import { EnquirySummaryIntl } from 'client/pages/EnquiriesPage/ViewEnquiryPage/EnquirySummary/EnquirySummary.intl';
import { viewEnquiryPageIntl } from 'client/pages/EnquiriesPage/ViewEnquiryPage/ViewEnquiryPage.intl';
import {
    createObservationButtonIntl
} from 'client/pages/MapPage/components/CreateObservationButton/CreateObservationButton.intl';
import {
    creatingObservationSnackBarIntl
} from 'client/pages/MapPage/components/SnackBars/CreatingObservationSnackBar/CreatingObservationSnackBar.intl';
import {
    customMappingOrAnnotationsSnackBarIntl
} from 'client/pages/MapPage/components/SnackBars/CustomMappingOrAnnotationsSnackBarIntl/CustomMappingOrAnnotationsSnackBar.intl';
import { dateInputIntl } from 'client/components/GDS/DateInput/DateInput.intl';
import { dialogIntl } from 'client/components/aria/Dialog/Dialog.intl';
import {
    dynamicLegendButtonIntl
} from 'client/pages/MapPage/components/DynamicLegend/DynamicLegendButton/DynamicLegendButton.intl';
import { workpackExportOptionsIntl } from 'client/pages/WorkpacksPage/components/WorkpackExportOptions/WorkpackExportOptions.intl';
import { workpackPrintPreviewIntl } from 'client/pages/WorkpacksPage/components/WorkpackPrintPreview/WorkpackPrintPreview.intl';
import { featurePanelOpenButtonIntl } from 'client/components/FeaturePanelOpenButton/FeaturePanelOpenButton.intl';
import { feedbackFormIntl } from 'client/components/Feedback/FeedbackForm/FeedbackForm.intl';
import { feedbackPromptIntl } from 'client/components/Feedback/FeedbackPrompt/FeedbackPrompt.intl';
import { feedbackPageIntl } from 'client/components/Feedback/FeedbackPage/FeedbackPage.intl';
import { footerIntl } from 'client/components/suc/Footer/Footer.intl';
import { generalIntl } from './general.intl';
import { highContrastButtonIntl } from 'client/pages/MapPage/components/HighContrastButton/HighContrastButton.intl';
import { homePageIntl } from 'client/pages/HomePage/HomePage.intl';
import {
    isolatedViewIntl
} from 'client/pages/MapPage/components/SnackBars/IsolatedViewsSnackBar/IsolatedViewsSnackBar.intl';
import { isolatedViewsIntl } from 'client/pages/MapPage/components/MapMenu/IsolatedViews/IsolatedViews.intl';
import { listWorkpackPageIntl } from 'client/pages/WorkpacksPage/ListWorkpackPage/ListWorkpackPage.intl';
import { listEnquiryPageIntl } from 'client/pages/EnquiriesPage/ListEnquiryPage/ListEnquiryPage.intl';
import { listObservationPageIntl } from 'client/pages/ObservationsPage/ListObservationsPage/ListObservationPage.intl';
import { loadingIntl } from 'client/components/ui/Loading/Loading.intl';
import { loggedOutIntl } from 'client/components/suc/LoggedOut/LoggedOut.intl';
import { mapInfoIntl } from 'client/pages/MapPage/components/MapInfo/MapInfo.intl';
import { mapMenuIntl } from 'client/pages/MapPage/components/MapMenu/MapMenu.intl';
import { mapPageIntl } from 'client/pages/MapPage/MapPage.intl';
import { mapPreviewIntl } from 'client/components/MapPreview/MapPreview.intl';
import { mapTabsIntl } from 'client/pages/MapPage/components/MapMenu/MapTabs/MapTabs.intl';
import { mapToolbarIntl } from 'client/pages/MapPage/components/MapToolBar/MapToolbar.intl';
import { myLocationButtonIntl } from 'client/components/MyLocationButton/MyLocationButton.intl';
import { navbarIntl } from 'client/components/suc/Navbar/Navbar.intl';
import { networkCoverageLegendIntl } from 'client/pages/MapPage/components/NetworkCoverageLegend/NetworkCoverageLegend.intl';
import { networkCoverageSnackBarIntl } from 'client/pages/MapPage/components/SnackBars/NetworkCoverageSnackBar/NetworkCoverageSnackBar.intl';
import { notificationIntl } from 'client/components/GDS/Notification/Notification.intl';
import { observationsTabIntl } from 'client/pages/MapPage/components/MapMenu/ObservationsTab/ObservationsTab.intl';
import { organisationModalIntl } from 'client/components/suc/OrganisationModal/OrganisationModal.intl';
import { paginationIntl } from 'client/components/aria/Pagination/Pagination.intl';
import { optInIntl } from 'client/components/aria/OptIn/OptIn.intl';
import { phaseBannerIntl } from 'client/components/suc/PhaseBanner/PhaseBanner.intl';
import { routeErrorsIntl } from 'client/utils/routes/RouteErrors.intl';
import { saveObservationPageIntl } from 'client/pages/ObservationsPage/SaveObservationPage/SaveObservationPage.intl';
import { searchIntl } from 'client/pages/MapPage/components/MapToolBar/Search/Search.intl';
import {
    selectFeatureAttributeTableIntl
} from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeatureAttributeTable/SelectFeatureAttributeTable.intl';
import { selectFeatureIntl } from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeature.intl';
import {
    selectFeaturePanelIntl
} from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeaturePanel/SelectFeaturePanel.intl';
import {
    enhancedMeasuresIntl
} from 'client/pages/MapPage/components/SnackBars/EnhancedMeasuresSnackBar/EnhancedMeasuresSnackBar.intl';
import { showResultsIntl } from 'client/components/aria/ShowResults/ShowResults.intl';
import { signOutIntl } from 'client/components/suc/Navbar/SignOut/SignOut.intl';
import {
    supplementaryDataErrorIntl
} from 'client/pages/MapPage/components/SnackBars/SupplementaryDataErrorSnackBar/SupplementaryDataErrorSnackBar.intl';
import {
    supplementaryDataTab
} from 'client/pages/MapPage/components/MapInteractions/SelectFeature/SelectFeaturePanel/SupplementaryDataTab/SupplementaryDataTab.intl';
import { termsPageIntl } from 'client/pages/TermsPage/TermsPage.intl';
import { reaffirmationPageIntl } from 'client/pages/ReaffirmationPage/ReaffirmationPage.intl';
import { treeIntl } from 'client/components/ui/Tree/Tree.intl.js';
import { viewObservationPageIntl } from 'client/pages/ObservationsPage/ViewObservationPage/ViewObservationPage.intl';
import { tooltipIntl } from 'client/components/aria/Tooltip/Tooltip.intl';
import { warningTextIntl } from 'client/components/aria/WarningText/WarningText.intl';
import { workspaceIntl } from 'client/pages/HomePage/Workspace/Workspace.intl';
import { AOIMarkUpSnackBarIntl } from 'client/pages/MapPage/components/SnackBars/MobileSnackBar/AOIMarkUpSnackBar.intl';
import { legendIntl } from 'client/pages/MapPage/components/Legend/Legend.intl';
import { enhancedMeasuresModalIntl } from 'client/pages/MapPage/components/EnhancedMeasuresModal/EnhancedMeasuresModal.intl';
import { workpackAlertWarningIntl } from 'client/pages/WorkpacksPage/components/WorkpackAlerts/WorkpackAlertWarning/WorkpackAlertWarning.intl';
import { enhancedMeasuresListIntl } from 'client/pages/MapPage/components/MapMenu/EnhancedMeasures/EnhancedMeasuresList/EnhancedMeasuresList.intl';
import { infoBoxIntl } from 'client/pages/MapPage/components/InfoBox/InfoBox.intl';
import { workpackOmissionModalIntl } from 'client/pages/WorkpacksPage/components/Omissions/WorkpackOmissionModal/WorkpackOmissionModal.intl';
import { redactedAssetPanelIntl } from 'client/pages/MapPage/components/MapInteractions/SelectFeature/RedactedAssetPanel/RedactedAssetPanel.intl';
import { floatingDrawPanelIntl } from 'client/pages/MapPage/components/FloatingDrawPanel/FloatingDrawPanel.intl';
import { lineWidthFieldIntl } from 'client/pages/MapPage/components/MapToolBar/LineWidthField/LineWidthField.intl';
import { platformNoticesPageIntl } from 'client/pages/PlatformNoticesPage/PlatformNoticesPage.intl';

const combinedMessages = {};

Object.values(LOCALES).forEach(locale => {
    combinedMessages[locale] = {
        ...AOIMarkUpSnackBarIntl[locale],
        ...CMSPageIntl[locale],
        ...coverageAssetOwnersIntl[locale],
        ...errorSummaryIntl[locale],
        ...EnquiryFormIntl[locale],
        ...workpackFormIntl[locale],
        ...workpackSummaryIntl[locale],
        ...workpackAlertsIntl[locale],
        ...workpackAlertSuccessIntl[locale],
        ...workpackAlertModalIntl[locale],
        ...ariaSearchIntl[locale],
        ...assetOwnersIntl[locale],
        ...contactDetailsTabIntl[locale],
        ...assetsHiddenSnackBarIntl[locale],
        ...autoLogoutIntl[locale],
        ...bookmarkIntl[locale],
        ...bookmarkPageIntl[locale],
        ...characterCountIntl[locale],
        ...contactDetailsIntl[locale],
        ...createEnquiryPageIntl[locale],
        ...enquiryActivityTypeIntl[locale],
        ...enquiryAlertsIntl[locale],
        ...enquiryAlertModalIntl[locale],
        ...enquiryWarningIntl[locale],
        ...createWorkpackPageIntl[locale],
        ...createObservationButtonIntl[locale],
        ...creatingObservationSnackBarIntl[locale],
        ...customMappingOrAnnotationsSnackBarIntl[locale],
        ...EnquirySummaryIntl[locale],
        ...viewEnquiryPageIntl[locale],
        ...dateInputIntl[locale],
        ...dialogIntl[locale],
        ...dynamicLegendButtonIntl[locale],
        ...workpackExportOptionsIntl[locale],
        ...workpackPrintPreviewIntl[locale],
        ...featurePanelOpenButtonIntl[locale],
        ...feedbackFormIntl[locale],
        ...feedbackPromptIntl[locale],
        ...feedbackPageIntl[locale],
        ...footerIntl[locale],
        ...generalIntl[locale],
        ...highContrastButtonIntl[locale],
        ...homePageIntl[locale],
        ...isolatedViewIntl[locale],
        ...isolatedViewsIntl[locale],
        ...legendIntl[locale],
        ...listWorkpackPageIntl[locale],
        ...listEnquiryPageIntl[locale],
        ...listObservationPageIntl[locale],
        ...loadingIntl[locale],
        ...loggedOutIntl[locale],
        ...mapInfoIntl[locale],
        ...mapMenuIntl[locale],
        ...mapPageIntl[locale],
        ...mapPreviewIntl[locale],
        ...mapTabsIntl[locale],
        ...mapToolbarIntl[locale],
        ...myLocationButtonIntl[locale],
        ...navbarIntl[locale],
        ...networkCoverageLegendIntl[locale],
        ...networkCoverageSnackBarIntl[locale],
        ...notificationIntl[locale],
        ...observationsTabIntl[locale],
        ...organisationModalIntl[locale],
        ...optInIntl[locale],
        ...paginationIntl[locale],
        ...phaseBannerIntl[locale],
        ...routeErrorsIntl[locale],
        ...saveObservationPageIntl[locale],
        ...searchIntl[locale],
        ...selectFeatureAttributeTableIntl[locale],
        ...selectFeatureIntl[locale],
        ...selectFeaturePanelIntl[locale],
        ...enhancedMeasuresIntl[locale],
        ...showResultsIntl[locale],
        ...signOutIntl[locale],
        ...supplementaryDataErrorIntl[locale],
        ...supplementaryDataTab[locale],
        ...termsPageIntl[locale],
        ...reaffirmationPageIntl[locale],
        ...treeIntl[locale],
        ...viewWorkpackPageIntl[locale],
        ...viewObservationPageIntl[locale],
        ...tooltipIntl[locale],
        ...warningTextIntl[locale],
        ...workspaceIntl[locale],
        ...enhancedMeasuresModalIntl[locale],
        ...workpackAlertWarningIntl[locale],
        ...enhancedMeasuresListIntl[locale],
        ...infoBoxIntl[locale],
        ...workpackOmissionModalIntl[locale],
        ...redactedAssetPanelIntl[locale],
        ...floatingDrawPanelIntl[locale],
        ...lineWidthFieldIntl[locale],
        ...platformNoticesPageIntl[locale]
    };
});

export default combinedMessages;
